import styles from './ComingSoon.module.css';

export function ComingSoon() {
  return (
    <main className={styles.root}>
      <span className={styles.brand}>Profind</span>
      <h1 className={styles.title}>
        Próximamente
        <span className={styles.dot} aria-hidden="true" />
      </h1>
      <p className={styles.subtitle}>Estamos terminando los últimos detalles.</p>
    </main>
  );
}
